export default "__VITE_ASSET__m$GqofWP__"